'use strict'

import ReportMaterialsGroup from './ReportMaterialsGroup.js'

export default class ReportDebitsGroup extends ReportMaterialsGroup {
  constructor (config) {
    super(config)

    this.debitError = null
  }

  hasChanges () {
    return super.hasChanges() || this.debitError
  }

  setLoadedData (data) {
    this.setLoadedRecords(data.result.debitResults)
    this.recordsFromOtherDepartures = data.result.otherResults || []

    this.debitError = data.result.error1C || null
    // this.debitsApproved = data.result.debitsApproved
  }

  hasEqualComplexKeys (record1, record2) {
    if (record1.recId !== record2.recId) {
      return false
    }
    if (record1.projectKey !== record2.projectKey) {
      return false
    }
    if (record1.stockKey !== record2.stockKey) {
      return false
    }
    if (record1.toolKey !== record2.toolKey) {
      return false
    }
    return true
  }
}
